import { getFlag } from "@/config/rdoFlags";
import { EquipmentsModule } from "@/components/rdo/modules/EquipmentsModule";
import { LegacyEquipmentsSection } from "@/components/rdo/legacy/LegacyEquipmentsSection";
import { normalizeFromRDOPAGE, toRDOPAGEPayload } from "@/domain/rdo/normalize";
import type { RDO } from "@/domain/rdo/schema";

export function EquipmentsForRDO({
  legacyValue,
  onLegacyChange,
  mode,
  // Legacy props for compatibility
  showEquipmentModal,
  setShowEquipmentModal,
  showEditEquipmentModal,
  setShowEditEquipmentModal,
  editingEquipment,
  setEditingEquipment,
  handleAddEquipment,
  handleEditEquipment,
  handleDeleteEquipment,
  isEditing,
  isSectionEnabled,
}: {
  legacyValue: any;                 // shape atual usado em RDO.tsx (equipamentos)
  onLegacyChange: (v: any) => void; // setter do RDO.tsx
  mode: "edit" | "view";
  // Legacy props
  showEquipmentModal?: boolean;
  setShowEquipmentModal?: (show: boolean) => void;
  showEditEquipmentModal?: boolean;
  setShowEditEquipmentModal?: (show: boolean) => void;
  editingEquipment?: any;
  setEditingEquipment?: (equipment: any) => void;
  handleAddEquipment?: (equipment: any) => void;
  handleEditEquipment?: (index: number, equipment: any) => void;
  handleDeleteEquipment?: (index: number) => void;
  isEditing?: boolean;
  isSectionEnabled?: (section: string) => boolean;
}) {
  if (!getFlag("useNewEquipmentsInRDO")) {
    // Render legado de Equipamentos (manter como está)
    return (
      <LegacyEquipmentsSection 
        value={legacyValue} 
        onChange={onLegacyChange} 
        mode={mode}
        showEquipmentModal={showEquipmentModal}
        setShowEquipmentModal={setShowEquipmentModal}
        showEditEquipmentModal={showEditEquipmentModal}
        setShowEditEquipmentModal={setShowEditEquipmentModal}
        editingEquipment={editingEquipment}
        setEditingEquipment={setEditingEquipment}
        handleAddEquipment={handleAddEquipment}
        handleEditEquipment={handleEditEquipment}
        handleDeleteEquipment={handleDeleteEquipment}
        isEditing={isEditing}
        isSectionEnabled={isSectionEnabled}
      />
    );
  }

  // 1) Converte do legado -> RDO (somente equipments)
  // IMPORTANTE: não definir `equipments` aqui. O normalizador resolve
  // `legacy.equipments ?? legacy.equipment ?? legacy.equipamentos`; um
  // `equipments: []` presente sombrearia o `equipment` legado e zeraria a lista.
  const mockRDO = {
    id: "",
    obraId: "",
    date: "",
    status: "draft" as const,
    workforce: [],
    equipment: legacyValue || [],
    activities: [],
    occurrences: [],
    materials: { received: [], used: [] },
    comments: [],
    photos: [],
    videos: [],
    attachments: [],
    createdAt: "",
    updatedAt: "",
  };
  
  const rdo: RDO = normalizeFromRDOPAGE(mockRDO);

  // 2) Renderiza o módulo novo com a UX do Preenchendo
  return (
    <EquipmentsModule
      value={rdo.equipments || []}
      mode={mode === "edit" ? "edit" : "view"}
      onChange={(equipments) => {
        // 3) Converte de volta p/ o payload legado
        const updatedRdo = { ...rdo, equipments };
        const payload = toRDOPAGEPayload(updatedRdo as RDO);
        onLegacyChange(payload.equipment);
      }}
    />
  );
}